export const OPTIMIZELY_PROJECT_NAME = 'default';
export const RECEIVED_ASSIGNMENTS = '@@abservice/RECEIVED_ASSIGNMENTS';
export const AB_OVERRIDES_COOKIE_KEY = 'testAbSystemOverrides';
export const AB_ROOT_KEY = 'absystem';

export const VISITOR_ID_TYPES = {
    sessionId: 'sessionId',
    trackingId: 'trackingId',
};

export const VARIANT_ON = 'on';
export const VARIANT_OFF = 'off';

export const PINATA_EMAIL_FIRST_LOGIN_AND_SIGNUP = {
    experimentId: 'pinata_email_first_login_and_signup',
    defaultAssignment: VARIANT_OFF,
    isFeatureFlag: false,
    visitorIdType: 'trackingId',
};

export const PINATA_MFA_AUTH = {
    experimentId: 'pinata_mfa_auth',
    defaultAssignment: VARIANT_OFF,
    isFeatureFlag: false,
    visitorIdType: 'trackingId',
};

export const PINATA_REMOVE_UPCOMING_APPT_PAGE = {
    experimentId: 'pinata_remove_upcoming_appointments_mobile_web',
    defaultAssignment: VARIANT_OFF,
    isFeatureFlag: false,
    visitorIdType: 'trackingId',
};
